import React from 'react'

export function Button({ children, ...props }) {
  return (
    <button 
      className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded" 
      {...props}
    >
      {children}
    </button>
  )
}



// import * as React from "react"
// import { cva } from "class-variance-authority"
// import { cn } from "./lib/utils"

// const buttonVariants = cva(
//   "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background",
//   {
//     variants: {
//       variant: {
//         default: "bg-primary text-primary-foreground hover:bg-primary/90",
//         destructive:
//           "bg-destructive text-destructive-foreground hover:bg-destructive/90",
//         outline:
//           "border border-input hover:bg-accent hover:text-accent-foreground",
//         secondary:
//           "bg-secondary text-secondary-foreground hover:bg-secondary/80",
//         ghost: "hover:bg-accent hover:text-accent-foreground",
//         link: "underline-offset-4 hover:underline text-primary",
//       },
//       size: {
//         default: "h-10 py-2 px-4",
//         sm: "h-9 px-3 rounded-md",
//         lg: "h-11 px-8 rounded-md",
//       },
//     },
//     defaultVariants: {
//       variant: "default",
//       size: "default",
//     },
//   }
// )

// const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => {
//   return (
//     <button
//       className={cn(buttonVariants({ variant, size, className }))}
//       ref={ref}
//       {...props}
//     />
//   )
// })
// Button.displayName = "Button"

// export { Button, buttonVariants }